import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeoForPath } from "../config/publicPageSeo";
import { applyPageSeo, restoreDefaultSeo } from "../utils/siteSeo";

function PublicPageSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getSeoForPath(pathname);

    if (seo) {
      applyPageSeo(seo);
      return undefined;
    }

    restoreDefaultSeo();
    return undefined;
  }, [pathname]);

  return null;
}

export default PublicPageSeo;
